import { Flex, Progress, Text } from '@chakra-ui/react';

const ProgressItem = ({ text, value, total }) => (
  <Flex direction="column">
    <Flex fontSize="xs" my="1" justifyContent="space-between">
      <Text>{text}</Text>
      <Text>
        <Text as="span" fontWeight="bold" mx="0.5">{value}</Text>
        /
        <Text as="span" mx="0.5">{total}</Text>
      </Text>
    </Flex>
    <Progress size="xs" colorScheme="gray" value={(value * 100) / total} />
  </Flex>
);

export default ProgressItem;
